import { useValidateQueryParams } from "query_parameters/paramsHelper";
import { buildQueryParams, compareSearchParams, compareObjects } from "lib/general-helper.js";

export const useValidateURL = () => {
  const validateQueryParams = useValidateQueryParams();

  return (prevProps, curProps, params) => {
    const { summonerName, region } = curProps;

    const { location, history, queryString, page } = params;

    if (queryString.queueType === "normal_aram" || queryString.queueType === "nexus_blitz") {
      delete queryString.role;
    }

    const validatedParams = validateQueryParams({
      queryParams: queryString,
      page: page || "overview",
      queryParamType: "profile",
    });

    const newParams = `?${buildQueryParams(validatedParams)}`;
    const isQueryEqual = compareSearchParams(prevProps && prevProps.location.search, newParams);
    const isParamsClean = compareObjects(queryString, validatedParams);

    // TODO FIX THIS LOGIC ("too many calls")
    if (
      // (!prevProps && (!isQueryEqual || !isParamsClean)) ||
      // ((prevProps && prevProps.location.pathname) !==
      //   (curProps && curProps.location.pathname)) ||
      !isQueryEqual ||
      !isParamsClean
    ) {
      return history.replace({
        pathname: location.pathname,
        search: newParams,
        state: {
          ...history.state,
          validation: true,
        },
      });
    }
  };
};
